export class RemoveFavoriteResponse {
  constructor(responseJSON) {
    return responseJSON;
  }
}


// WEBPACK FOOTER //
// ./js/api/RemoveFavoriteResponse.js